import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'videoTitleTransform'})

export class VideoTitleTransform {

    transform( video?: any){

      if ( video ) {
        const { day, month, year } = video.date;
        const { city, state, country } = video.location;
        const { occasion, venue } = video.meta;
        const nationState = ( country === 'United States' ) ? `${ state || "state unknown" }` : `${ country || "country unknown" }`;
        let title = `${ day }/${ month + 1 }: `;

        if ( !occasion && !venue ) title += `${ city || 'city unknown' } - ${ nationState }`;
        if ( occasion && !venue ) title += `${ occasion } - ${ city || 'city unknown' } - ${ nationState }`;
        if ( !occasion && venue ) title += `${ venue } - ${ city || 'city unknown' } - ${ nationState }`;
        if ( occasion && venue ) title += `${ occasion } - ${ venue } - ${ city || nationState }`

        return title;
      }

    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/pipes/video-title.transform.ts